'use es6';

export const FINDER = 'FINDER';
export const EDITOR = 'EDITOR';